import React, { useState } from "react"

export default function AlertModal({message, onAccept}) {
    return(
        <div className='alert modal'>
            <p>{message}</p>
            <button className="dark" onClick={()=>onAccept()}>Aceptar</button>
        </div>
    );
}